
// Action types
export enum dsDashboardTypes {
    SET_SELECTED_DELETE_TABLE = "@dsDashboard/SET_SELECTED_DELETE_TABLE",
    SET_SELECTED_EDIT_TABLE = "@dsDashboard/SET_SELECTED_EDIT_TABLE",
    SET_ACTIVE_DASHBOARD_VIEWS = "@dsDashboard/SET_ACTIVE_DASHBOARD_VIEWS",
    SET_DASHBOARD_VIEW_DATA = "@dsDashboard/SET_DASHBOARD_VIEW_DATA",
    SET_ERD_VIEW_METADATA = "@dsDashboard/SET_ERD_VIEW_METADATA",
    SET_GENERATED_PROTOBUF_DATA = "@dsDashboard/SET_GENERATED_PROTOBUF_DATA",
    SET_SQL_VIEW_DATA = "@dsDashboard/SET_SQL_VIEW_DATA"
}

// Reducer state
export interface IDsDashboardState {
    selectedDeleteTable: any;
    selectedEditTable: any;
    activeDashboardViews: string[];
    dashboardKey: number;
    codeViewData: any;
    jsonViewData: any;
    erdViewData: any;
    protobufViewData: any;
    generatedProtobufData: string;
    sqlViewData: any;
}
